import { createSlice } from '@reduxjs/toolkit';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AsyncThunkAction } from '../asyncThunk';
const initialState = {
    tenantList: [],
    currentTenant: null
}


export const initTenantList = AsyncThunkAction('tenant/list', API_BASE_URL + ApiURLs.Tenant.getTenantList)
export const switchTenant = AsyncThunkAction('tenant/switch', API_BASE_URL + ApiURLs.Tenant.switchTenant)

const tenantSlice = createSlice({
    name: 'tenant',
    initialState: initialState,
    reducers: {
        setCurrentTenant: (state, action) => {
            if (action?.payload) {
                state.currentTenant = action.payload
                window.slbConfig.accountId = action?.payload?.tenantId
            }
        },     
    },
    extraReducers: (builder) => {
        builder
            .addCase(initTenantList.pending, (state, action) => {
                // state.userInfo.status = RequestStatus.Pending;
            })
            .addCase(initTenantList.fulfilled, (state, action) => {
                state.tenantList = action.payload.data
            }).addCase(initTenantList.rejected, (state, action) => {
                // state.userInfo.status = RequestStatus.Rejected
            })
    }
})

export const { setCurrentTenant } = tenantSlice.actions;
export default tenantSlice.reducer